"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetStrategyValueOptionList = exports.buildValueFilter = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../__generated__/graphql");
const ramda_1 = require("ramda");
const use_get_strategy_values_hook_1 = require("./use-get-strategy-values.hook");
const buildValueFilter = (
// eslint-disable-next-line default-param-last
excludeNodeIds = [], searchString, baseFilter) => {
    var _a, _b;
    const normalizedSearch = (searchString === null || searchString === void 0 ? void 0 : searchString.trim()) || undefined;
    const filter = Object.assign({}, (baseFilter !== null && baseFilter !== void 0 ? baseFilter : {}));
    if (excludeNodeIds.length) {
        filter.none = Object.assign(Object.assign({}, ((_a = filter.none) !== null && _a !== void 0 ? _a : {})), { sourceNodeIds: { hasSome: excludeNodeIds } });
    }
    if (normalizedSearch) {
        filter.some = Object.assign(Object.assign({}, ((_b = filter.some) !== null && _b !== void 0 ? _b : {})), { value: { contains: normalizedSearch, mode: graphql_1.StringFilterMode.Insensitive } });
    }
    return Object.keys(filter).length > 0 ? filter : undefined;
};
exports.buildValueFilter = buildValueFilter;
const useGetStrategyValueOptionList = (_a) => {
    var { excludeNodeIds = [], filter } = _a, props = __rest(_a, ["excludeNodeIds", "filter"]);
    const excludeNodeIdsKey = (0, react_1.useMemo)(() => excludeNodeIds.join(','), [excludeNodeIds]);
    const mergedFilter = (0, react_1.useMemo)(() => (0, exports.buildValueFilter)(excludeNodeIds, undefined, filter), 
    // excludeNodeIds is used via excludeNodeIdsKey for stable reference comparison.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [excludeNodeIdsKey, filter]);
    const _b = (0, use_get_strategy_values_hook_1.useGetStrategyValues)(Object.assign(Object.assign({}, props), { filter: mergedFilter })), { data, previousData, isLoading, isRefetching, refetch } = _b, restData = __rest(_b, ["data", "previousData", "isLoading", "isRefetching", "refetch"]);
    const [searchText, setSearchText] = (0, react_1.useState)('');
    const onRefetch = (0, react_1.useCallback)((searchString) => {
        setSearchText(searchString);
        return refetch({
            filter: (0, exports.buildValueFilter)(excludeNodeIds, searchString, filter),
        });
        // excludeNodeIds is used via excludeNodeIdsKey for stable reference comparison.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [excludeNodeIdsKey, filter, refetch]);
    return Object.assign(Object.assign({}, restData), { isLoading,
        searchText, data: isLoading && (!data || (0, ramda_1.isEmpty)(data)) ? previousData : data, refetch: onRefetch });
};
exports.useGetStrategyValueOptionList = useGetStrategyValueOptionList;
